// syllablesConfig.js
import { getAssetUrl } from '../../api/config';

const syllablesConfig = {
    id: 'syllables',
    title: 'Syllable Exercise',
    headerColor: '#4CAF50', // Verde per Dudi
    planetBackground: '/assets/images/general/pianeta_verde.jpg',
    marsImage: '/assets/images/general/singing_mars.png',
    testImage: '/assets/images/general/demo_no_background.png',
    dudiImage: '/assets/images/characters/Dudi.png', // Assumi che esista
    marsSize: 600,
    character: 'Dudi',
    controlColors: {
        repeat: 'yellow',
        record: 'lightgray',
        check: 'lightgreen'
    },
    totalLevels: 7,
    
    // Configurazione specifica per ogni livello (Storyline)
    storyline: {
        1: {
            item: 'cassetta degli attrezzi',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3_FIRST.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve la cassetta degli attrezzi per riparare il razzo.', audio: getAssetUrl('/audios/storyline/it/mars16.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene, se volete la cassetta degli attrezzi cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi4.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Complimenti. Hai cantato molto bene, ecco la cassetta degli attrezzi', audio: getAssetUrl('/audios/storyline/it/dudix1.wav'), image: '/assets/images/rewards/syllables/toolbox.png' }
        },
        2: {
            item: 'motore',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve un nuovo motore del razzo.', audio: getAssetUrl('/audios/storyline/it/mars17.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene, se volete un nuovo motore del razzo, cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi5.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Bene. Ottimo ritmo. Ecco il nuovo motore del razzo', audio: getAssetUrl('/audios/storyline/it/dudix2.wav'), image: '/assets/images/rewards/syllables/engine.png' }
        },
        3: {
            item: 'casco',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve un nuovo casco spaziale.', audio: getAssetUrl('/audios/storyline/it/mars18.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene, se volete un nuovo casco spaziale cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi6.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Complimenti. Hai cantato molto bene, ecco il nuovo casco spaziale', audio: getAssetUrl('/audios/storyline/it/dudix3.wav'), image: '/assets/images/rewards/syllables/helmet.png' }
        },
        4: {
            item: 'computer',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve un nuovo computer di bordo.', audio: getAssetUrl('/audios/storyline/it/mars19.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene, se volete un nuovo computer di bordo cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi7.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Super. La canzone era perfetta. Ecco il nuovo computer di bordo.', audio: getAssetUrl('/audios/storyline/it/dudix4.wav'), image: '/assets/images/rewards/syllables/computer.png' }
        },
        5: {
            item: 'volante',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve un nuovo volante del razzo.', audio: getAssetUrl('/audios/storyline/it/mars20.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene, se volete un nuovo volante del razzo cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi8.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Benissimo, per questa bella canzone vi darò il nuovo volante del razzo.', audio: getAssetUrl('/audios/storyline/it/dudix5.wav'), image: '/assets/images/rewards/syllables/steering_wheel.png' }
        },
        6: {
            item: 'punta',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve una nuova punta del razzo.', audio: getAssetUrl('/audios/storyline/it/mars21.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene se volete una nuova punta cantate con me questa canzoncina.', audio: getAssetUrl('/audios/storyline/it/dudi9.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Super. Hai cantato benissimo. Ecco la nuova punta del razzo.', audio: getAssetUrl('/audios/storyline/it/dudix6.wav'), image: '/assets/images/rewards/syllables/nose_cone.png' }
        },
        7: {
            item: 'finestrino',
            pre: [
                { name: 'Dudi', text: 'Cosa vi serve?', audio: getAssetUrl('/audios/storyline/it/dudi3.wav'), autoNext: true },
                { name: 'Mars', text: 'Ci serve un nuovo finestrino', audio: getAssetUrl('/audios/storyline/it/mars21bis.wav'), autoNext: true },
                { name: 'Dudi', text: 'Bene se volete un nuovo finestrino cantate con me questa canzoncina', audio: getAssetUrl('/audios/storyline/it/dudix7.wav'), autoNext: true }
            ],
            post: { name: 'Dudi', text: 'Super. Hai cantato benissimo. Ecco il nuovo finestrino.', audio: getAssetUrl('/audios/storyline/it/dudix8.wav'), image: '/assets/images/rewards/syllables/window.png' }
        }
    }
};

export default syllablesConfig;
